import { defineMessages } from 'react-intl';
export default defineMessages({
	error: {
		id: 'cmdb.object.card.error.loading.object',
		defaultMessage: 'Error occured loading object',
		description: 'Displayed when a value for a CMDB Assets field does not load',
	},
	expandLabel: {
		id: 'cmdb.object.card.expand.label',
		defaultMessage: 'Expand object details',
		description: 'Label for the expand button on the CMDB object field',
	},
	collapseLabel: {
		id: 'cmdb.object.card.collapse.label',
		defaultMessage: 'Collapse object details',
		description: 'Label for the collapse button on the CMDB object field',
	},
	noAttributes: {
		id: 'cmdb.object.card.no.attributes',
		defaultMessage: 'No attributes to display',
		description: 'Shown when an expanded CMDB object card has no attribute details available',
	},
	loadingAttributes: {
		id: 'cmdb.object.card.loading.attributes',
		defaultMessage: 'Loading object details',
		description:
			'Accessible label for the spinner shown while a CMDB object card lazily loads its attributes on expand',
	},
});
